import { computed } from '@vue/composition-api';

const showableNumbers = (start: number, end: number): number[] => {
  return [...Array(end + 1)].map((_, i) => i).filter(i => i >= start);
};

export const useAdvisorSearchPagination = (props: {
  query: string;
  currentPage: number;
  totalPage: number;
  maxIntervalFromStartPage: number;
  limitOfShowPages: number;
}) => {
  const firstPage = 1;
  const lastPage = computed(() => props.totalPage);
  const prevPage = computed(() => Math.max(props.currentPage - 1, firstPage));
  const nextPage = computed(() =>
    Math.min(props.currentPage + 1, props.totalPage),
  );
  const startPage = computed(() =>
    Math.max(props.currentPage - props.maxIntervalFromStartPage, firstPage),
  );
  const endPage = computed(() =>
    Math.min(startPage.value + props.limitOfShowPages - 1, props.totalPage),
  );
  const pages = computed(() => showableNumbers(startPage.value, endPage.value));
  const showPrevButton = computed(() => props.currentPage !== firstPage);
  const showNextButton = computed(() => props.currentPage !== lastPage.value);

  const path = (page: number) => {
    return page === 1
      ? { query: { keyword: props.query } }
      : {
          query: {
            keyword: props.query,
            page,
          },
        };
  };

  return {
    firstPage,
    lastPage,
    prevPage,
    nextPage,
    pages,
    showPrevButton,
    showNextButton,
    path,
  };
};
